import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    DateField, Icon, Loader, Accordion, Chevron
} from '@jutro/components';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyDwellingInfo.metadata.json5';
import messages from './PolicyDwellingInfo.messages';
import styles from './PolicyDwellingInfo.module.scss';
import HomeCoverageTable from '../HomeCoverageTable/HomeCoverageTable';
import WCMotorDetailsTable from './../WCMotorDetailsTable/WCMotorDetailsTable';
import PolicyScheduleItemsComponent from './../../PolicyScheduleItemsComponent/PolicyScheduleItemsComponent';
import ScheduleItemsComponent from './../../ScheduleItemsComponent/ScheduleItemsComponent';
const getFormattedInfo = (message, key, value) => {
    return (
        <FormattedMessage
            {...message}
            values={{
                [key]: value
            }}
        />
    );
};

const translateYesNo = (keyObject, translator) => {
    const object = _.cloneDeep(keyObject);
    const appendingYear = (obj, key) => {
        let result = '';
        const mappingYear = {
            heatingUpgraded: 'heatingUpgradeYear',
            plumbingUpgraded: 'plumbingUpgradeYear',
            wiringUpgraded: 'wiringUpgradeYear',
            roofUpgraded: 'roofUpgradeYear'
        };
        const getDisplayYearKey = mappingYear[key];
        if (getDisplayYearKey && obj[key]) {
            result = `(${obj[getDisplayYearKey]})`;
        }
        return result;
    };
    if (!_.isEmpty(object)) {
        _.map(object, (value, key) => {
            if (typeof value === 'boolean') {
                object[key] = `${translator(
                    value ? messages.infoYes : messages.infoNo
                )} ${appendingYear(object, key)}`;
            }
        });
    }
    return object;
};

const checkValueisTrue = (val) => {
    return val === true || (val && val.indexOf('Yes')) ? true : false; 
}

const convertYesNo = (boolObj, translator) => {
    let val = '-' 
    if(boolObj){
        val = `${translator(boolObj ? messages.infoYes : messages.infoNo)}`;
    }
    return val;
}

//Pass the location on the 2nd parameter

const getHeaderSection = (title, title1, title2) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" messageProps={{label: "Accordion menuitem"}} className={styles.chevronStyle} />
            <h2 className={`${styles.customAccordion_cardTitle} ${styles.gwOverrideDefaultMargin}`}>{title}</h2>
            <div className={styles.row} >
                {title1 && <div > 
                    <h3 className={`${styles.customAccordion_cardTitle2} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
                </div>}
                {/* {title2 && <div><h3 className={`${styles.customAccordion_cardTitle2} ${styles.gwOverrideDefaultMargin}`}>{title2}</h3></div>} */}
                
            </div>
        </React.Fragment>
    );
};

function PolicyDwellingInfo(props) {
    const translator = useContext(TranslatorContext);
    const currencyFormatter = Intl.NumberFormat("en-CA", {style: "currency", currency: "CAD"});
    const [openItems, setOpenItems] = useState([]);
    const updateCoverages = (dwellingCoverages) => {
        const dwellingDTO = _.cloneDeep(dwellingCoverages);
            dwellingDTO.coverageDTOs = dwellingDTO.coverageDTOs || dwellingDTO.coverages;
            const coverages = dwellingDTO.coverageDTOs;
            const allCoverages = {
                sectionICoverages: [],
                sectionIICoverages: [],
                additionalLiabilityCoverages: [],
                additionalPropertyCoverages: [],
                scheduledItems: [],
                endorsements: [],
                optionalCoverages: [],
                combinedManOptCoverages: [],
                discounts: [],
                addlInterests: [],
                coverages: []
            };
            coverages.forEach((coverage) => {
                const cov = coverage;

                switch (cov.categoryCodeIdentifier) {
                    case 'HOPSectionICovCat':
                    case 'HODW_SectionI_HOE':
                        allCoverages.sectionICoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HOPSectionIICovCat':
                    case 'HODW_SectionII_HOE':
                        allCoverages.sectionIICoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HO_Endorsement_EY':
                        allCoverages.endorsements.push(cov);
                        break;
                    case 'HOPOptionalCovCat':
                        allCoverages.optionalCoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HOPAdditionalCovCat':
                    case 'HOLI_Additional_HOE':
                        allCoverages.additionalLiabilityCoverages.push(cov);
                        break;
                    case 'HOPPCAdditionalCovCat':
                    case 'HODW_Additional_HOE':
                        allCoverages.additionalPropertyCoverages.push(cov);
                        break;
                    case 'HOPScheduledItemCovCat':
                    case 'HODW_SchedulesCov_HOE':
                        if (cov.specialLimits) {
                            cov.specialLimits.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        } else if (cov.scheduledProperty) {
                            cov.scheduledProperty.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        }
                        break;
                    default:
                        break;
                }
            });
            allCoverages.coverages = dwellingDTO.coverageDTOs;
            allCoverages.addlInterests = dwellingDTO.additionalInterests;
            allCoverages.discounts = dwellingDTO.discounts;

            return allCoverages;
    };

    const getHomeOwnersData = useCallback(() => {
        const homeOwnersData = _.cloneDeep(props.value);
        homeOwnersData.dwellingDTO.forEach((dwellingDTO, index) => {
            if (!_.isEmpty(homeOwnersData.dwellingDTO[index].homeDetails)) {
                    homeOwnersData.dwellingDTO[index].homeDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].homeDetails,
                        translator
                    );
                    _.set(
                        homeOwnersData,
                        'dwellingDTO[${index}].homeDetails.distanceToFireHydrant',
                        getFormattedInfo(
                            messages.FeetToFireHydrant,
                            'distance',
                            homeOwnersData.dwellingDTO[index].homeDetails.distanceToFireHydrant
                        )
                    );
                    _.set(
                        homeOwnersData,
                        'dwellingDTO[0].homeDetails.distanceToFireStation',
                        getFormattedInfo(
                            messages.MilesToFireStation,
                            'miles',
                            homeOwnersData.dwellingDTO[index].homeDetails.distanceToFireStation
                        )
                    );
                }
                if (!_.isEmpty(homeOwnersData.dwellingDTO[index].constructionDetails)) {
                    homeOwnersData.dwellingDTO[index].constructionDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].constructionDetails,
                        translator
                    );
                }
                if (!_.isEmpty(homeOwnersData.dwellingDTO[index].miscDetails)) {
                    homeOwnersData.dwellingDTO[index].miscDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].miscDetails,
                        translator
                    );
                }
                if (_.isEmpty(homeOwnersData.dwellingDTO[index].mortgageeDetailsDTO)) {
                    homeOwnersData.dwellingDTO[index].mortgageeDetailsDTO = [];
                }
                homeOwnersData.dwellingDTO[index].allCoverages = updateCoverages(dwellingDTO);
        });


        return homeOwnersData;
    }, [props, translator]);

    const homeOwnersData = getHomeOwnersData();

    if (_.isEmpty(homeOwnersData)) {
        return null;
    }

    //Show/Hide package details code -- Start--
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

     const generatePackageDetails = useCallback(() => {
        const homeOwnersData = _.cloneDeep(props.value);
         const overrides = homeOwnersData.dwellingDTO.map((packageDTO, index) => {
            let packageName = translator({
                id: `typekey.HOPCoverageForm.${packageDTO.coverageForm}`,
                defaultMessage: "Coverage Form"
            }) + " " + translator({
                id: `typekey.CoveragePartType.${packageDTO.coveragePart}`,
                defaultMessage: "Package Type"
            });
            // var headName = props.productCode === "Commercial Property" ? `Building # ${packageDTO.name}` : 'Location # ' + packageDTO.address.displayName
            // var title1 = 'Package: '+ packageName;
            // var title = props.productCode === "Commercial Property" ? getHeaderSection(headName) : getHeaderSection(headName, title1);
            let header = "";
            if(props.productCode === 'Commercial Property'){
                const title = `Building # ${packageDTO.buildingNumber}: ${packageDTO.name}`;
                const title1 = `Item type: ${packageDTO.buildingType || '-'}`;
                const title2 = `Value: ${packageDTO.buildingValue || '-'}`;
                header = getHeaderSection(title, title1, title2);
            }
            else {
                const headName = `Location # ${packageDTO.displayName || packageDTO.address.displayName}`
                const title1 = `Package: ${packageName}`;
                const title2 = `Premium: ${ currencyFormatter.format(packageDTO.premium.amount)}`;
                header = getHeaderSection(headName, title1, title2)
            }
            
            const fireProtectionGrade = packageDTO.miscDetails.fireProtectionGrade;
            const ftfdVisible = ['1'];
            const ssVisible = ['1','2'];
            const scheduledItemsVisible = packageDTO.scheduledItems ? packageDTO.scheduledItems.filter((item)=> {
                return item.scheduleItems.length > 0
            }).length > 0 : false;

             return {
                 [`dwellingPackageDetailsContainer${index}`]: {
                    //header: getHeaderSection('Property Information', title)
                },
                 [`showContentToggleLink${index}`]: {
                     onClick: () => toggleShowHide(index)
                 },
                 [`contentDetailToggle${index}`]: {
                     icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                     message: _.includes(openItems, index)
                         ? translator(messages.hideCoverages)
                         : translator(messages.showCoverages)
                 },
                 [`protectionDetailsContainer${index}`]: {
                     visible: _.includes(openItems, index)
                 },
                 [`generalDetailsContainer${index}`]: {
                     visible: _.includes(openItems, index)
                 },
                 [`hoDetailsContainer${index}`]: {
                     visible: _.includes(openItems, index)
                 }, 
                 [`structureTypeID${index}`]: {
                    value: translator
                    ({
                        id: `typekey.StructureType_EY.${packageDTO.structureType}`,
                        defaultMessage: "Structure Type"
                    })
                 },
                 [`packageID${index}`]: {
                    value: translator
                        ({
                            id: `typekey.CoveragePartType.${packageDTO.coveragePart}`,
                            defaultMessage: "Package Type"
                        })  + " " +translator({
                            id: `typekey.HOPCoverageForm.${packageDTO.coverageForm}`,
                            defaultMessage: "Coverage From"
                        })
                 },
                 [`occupancyTypeID${index}`]: {
                     value: `${packageDTO.primaryType}` === 'true' ? translator
                         (messages.primary) : '-'
                 },  
                 [`isBasementFinished${index}`]: {
                    value: convertYesNo(packageDTO.isBasementFinished, translator)
                },
                [`RoofUpdateTypeColumn${index}` ]: {
                    visible: checkValueisTrue(packageDTO.constructionDetails.roofUpgraded)
                },  
                [`WiringUpdateTypeColumn${index}` ]: {
                    visible: checkValueisTrue(packageDTO.constructionDetails.wiringUpgraded)
                }, 
                [`PlumbingUpdateTypeColumn${index}` ]: {
                    visible: checkValueisTrue(packageDTO.constructionDetails.plumbingUpgraded)
                }, 
                [`packageAccordionCard${index}`]:{
                    header: header
                },
                [`waterCraftDetailsContainer${index}`]: {
                    visible: !!packageDTO.isMarine_EY,
                },
                [`vacationTrailerDetailsContainer${index}`]: {
                    visible: !!packageDTO.isTrailerPackage_EY,
                },
                [`waterCraftMotorDetailsContainer${index}`]: {
                    visible: !!packageDTO.isMarine_EY,
                },
                [`WaterCraftMotorDetails${index}`]: {
                    data: packageDTO.isMarine_EY ?  packageDTO.marine_EY.marineMotorDetails : []
                },
                [`mmDboatVlueHeader${index}`]: {
                    content : packageDTO.isMarine_EY ? `Boat Value:    ${packageDTO.marine_EY.mmdboatValue}` : ' ',
                    visible: packageDTO.isMarine_EY,
                },
                //Construction Details
                [`roofUpgradedColumn${index}`]: { 
                    visible : !packageDTO.constructionDetails.roofUpgraded === 'No'
                },  
                [`plumbingUpgradedColumn${index}`]: { 
                    visible : !packageDTO.constructionDetails.plumbingUpgraded === 'No'
                }, 
                [`heatingUpgradedColumn${index}`]: { 
                    visible : !packageDTO.constructionDetails.heatingUpgraded === 'No'
                },
                [`wiringUpgradedColumn${index}`]: {
                    visible : !packageDTO.constructionDetails.wiringUpgraded === 'No'
                },
                //Protection Details
                [`fullTimeFireDepartmentColumn${index}`]: { 
                    visible : ftfdVisible.includes(fireProtectionGrade)
                },  
                [`superiorShuttleColumn${index}`]: { 
                    visible : ssVisible.includes(fireProtectionGrade)
                },
                [`scheduledItemsContainer${index}`]:{
                    visible: scheduledItemsVisible
                },
                [`occupancyTypeColumn${index}`]:{
                    visible: props.productCode === 'Commercial Property'
                }
             };
         });

         return Object.assign({}, ...overrides);
     }, [homeOwnersData, openItems, toggleShowHide, props.value, translator]);
    //Show/Hide package details code -- End--

    const overrides = {
        ...generatePackageDetails()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            homecoveragetablecomponent: HomeCoverageTable,
            wcMotorDetailsTable: WCMotorDetailsTable,
            policyScheduleItemsComponent: PolicyScheduleItemsComponent,
            scheduleItemsComponent: ScheduleItemsComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={homeOwnersData}
            overrideProps={overrides}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

PolicyDwellingInfo.propTypes = {
    value: PropTypes.shape({}).isRequired
};

export default PolicyDwellingInfo;
